/**
 * Tipos das telas de landing page.
 *
 * A lista e o detalhe da API devolvem a MESMA linha (o select é `*` nos dois),
 * então um tipo só serve às duas telas — dois tipos "quase iguais" foi o que
 * fez a ficha da escola nascer em branco no módulo de mercado.
 */

import type { Bloco, PaginaLanding } from '@egba-do/shared'

export interface LandingPagina {
  id: string
  slug: string
  titulo: string
  categoriaId: string | null
  classeComunicacao: string
  publicada: boolean
  publicadaEm: string | null
  versao: number
  blocos: Bloco[]
  tema: PaginaLanding['tema']
  seo: PaginaLanding['seo']
  pixels: PaginaLanding['pixels']
  atualizadoEm: string
}

/** A forma que `renderizarPagina` consome — o recorte de página da linha. */
export function paraRender(p: LandingPagina): PaginaLanding {
  return {
    slug: p.slug,
    titulo: p.titulo,
    blocos: p.blocos,
    tema: p.tema ?? {},
    seo: p.seo ?? {},
    pixels: p.pixels ?? [],
  }
}
